import { render, staticRenderFns } from "./sharing_with_contact.vue?vue&type=template&id=c347ff6c&scoped=true&"
import script from "./sharing_with_contact.vue?vue&type=script&lang=js&"
export * from "./sharing_with_contact.vue?vue&type=script&lang=js&"
import style0 from "./sharing_with_contact.vue?vue&type=style&index=0&id=c347ff6c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c347ff6c",
  null
  
)

export default component.exports